import { render } from "./AnimeDiscovery.vue?vue&type=template&id=6c163137"
import script from "./AnimeDiscovery.vue?vue&type=script&lang=js"
export * from "./AnimeDiscovery.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__